import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { WithTranslation } from 'react-i18next'

import { Query } from 'react-apollo'
import { CompanyInfo, MANUFACTURERS_QUERY } from '.'
import { getManufacturer, setManufacturer } from 'utils'

import get from 'lodash/get'
import isNil from 'lodash/isNil'

import PageLayout from 'components/layout/pageLayout'
import Head from 'components/layout/head'
import Button from 'components/ui/button'
import Loader from 'components/ui/loader'
import ManufacturerOption from 'components/ui/manufacturerOption'

interface ManufacturersProps extends RouteComponentProps<any>, WithTranslation {}

type IErrorObject = {
  [k: string]: string | null
}

type ManufacturersState = {
  errors: IErrorObject | null
  success: boolean
  manufacturer: string | null
}

class Manufacturers extends Component<ManufacturersProps, ManufacturersState> {
  constructor(props: ManufacturersProps) {
    super(props)
    this.state = {
      errors: null,
      success: false,
      manufacturer: getManufacturer(),
    }
  }

  isEmpty = (value: string | null) => isNil(value) || value === ''

  handleSave = () => {
    const errors = {
      manufacturer: this.isEmpty(this.state.manufacturer) ? 'Error Message.' : null,
    }

    const hasErrors = Object.values(errors).find((error) => {
      if (error) return true
      return false
    })

    if (hasErrors) {
      this.setState({ errors, success: false })
    } else {
      setManufacturer(String(this.state.manufacturer))
      this.setState({ errors: null, success: true })
    }
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      manufacturer: e.currentTarget.value,
    })
  }

  render() {
    const { t } = this.props
    const { errors, success } = this.state

    return (
      <PageLayout pageTitle={t('manufacturer')}>
        <Head
          headline={t('manufacturerSelection')}
          subheadline={
            process.env.REACT_APP_ENV === 'rigips' ? t('appNameRigips') : t('appNameAbk')
          }
          error={errors ? true : false}
          message={
            errors ? 'Hersteller auswählen!' : success ? 'Erfolgreich gespeichert.' : undefined
          }
          actions={
            <Button primary onClick={this.handleSave}>
              {t('save')}
            </Button>
          }
        />
        <div className="my-65 px-48">
          <Query query={MANUFACTURERS_QUERY} fetchPolicy="network-only" notifyOnNetworkStatusChange>
            {({ loading, data }: any | null) => {
              if (loading) return <Loader />

              const manufacturers = get(data, 'getCompanies', [])

              return (
                <fieldset>
                  <legend className="sr-only">{t('manufacturerSelection')}</legend>
                  <div className="flex flex-wrap -mx-15">
                    {manufacturers.map((manufacturer: CompanyInfo) => (
                      <div className="w-4/12 md:w-3/12 xl:w-2/12 px-15 mb-30" key={manufacturer.id}>
                        <ManufacturerOption
                          onChange={this.handleChange}
                          manufacturer={manufacturer}
                          value={this.state.manufacturer}
                        />
                      </div>
                    ))}
                  </div>
                </fieldset>
              )
            }}
          </Query>
        </div>
      </PageLayout>
    )
  }
}

export default Manufacturers
